let swr: any = {};
try {
  swr = require('swr');
} catch (err) {}

export default swr;
